import { AxiosArgs } from 'src/api/types';
import axios, { AxiosResponse } from 'axios';
import { encodeBody } from 'src/api/client';

type SendReviewNotification = (params: {
  workspace_ux_id: string;
  email: string;
}) => Promise<AxiosArgs<AxiosResponse<unknown>>>;

export const sendReviewNotification: SendReviewNotification = async ({ workspace_ux_id, email }) => {
  const path = `/api/public/api/workspaces/${workspace_ux_id}/send-review-notifications`;

  return axios({
    method: 'POST',
    url: path,
    data: encodeBody({ workspace_ux_id, email }),
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  }).then((res) => res.data);
};
